[
  {
    "name": "Euro",
    "code": "EUR",
    "symbol": "€"
  },
  {
    "name": "United States Dollar",
    "code": "USD",
    "symbol": "$"
  },
  {
    "name": "United Arab Emirates Dirham",
    "code": "AED",
    "symbol": "د.إ."
  },
  {
    "name": "Afghan Afghani",
    "code": "AFN",
    "symbol": "Af"
  },
  {
    "name": "Albanian Lek",
    "code": "ALL",
    "symbol": "L"
  },
  {
    "name": "Armenian Dram",
    "code": "AMD",
    "symbol": "֏"
  },
  {
    "name": "Netherlands Antillean Guilder",
    "code": "ANG",
    "symbol": "ƒ"
  },
  {
    "name": "Angolan Kwanza",
    "code": "AOA",
    "symbol": "Kz"
  },
  {
    "name": "Argentine Peso",
    "code": "ARS",
    "symbol": "AR$"
  },
  {
    "name": "Australian Dollar",
    "code": "AUD",
    "symbol": "AU$"
  },
  {
    "name": "Aruban Florin",
    "code": "AWG",
    "symbol": "ƒ"
  },
  {
    "name": "Azerbaijani Manat",
    "code": "AZN",
    "symbol": "ман"
  },
  {
    "name": "Bosnia and Herzegovina Convertible Mark",
    "code": "BAM",
    "symbol": "KM"
  },
  {
    "name": "Barbadian Dollar",
    "code": "BBD",
    "symbol": "BBD$"
  },
  {
    "name": "Bangladeshi Taka",
    "code": "BDT",
    "symbol": "৳"
  },
  {
    "name": "Bulgarian Lev",
    "code": "BGN",
    "symbol": "лв."
  },
  {
    "name": "Bahraini Dinar",
    "code": "BHD",
    "symbol": "BD"
  },
  {
    "name": "Burundian Franc",
    "code": "BIF",
    "symbol": "FBu"
  },
  {
    "name": "Bermudian Dollar",
    "code": "BMD",
    "symbol": "$"
  },
  {
    "name": "Brunei Dollar",
    "code": "BND",
    "symbol": "B$"
  },
  {
    "name": "Bolivian Boliviano",
    "code": "BOB",
    "symbol": "Bs."
  },
  {
    "name": "Brazilian Real",
    "code": "BRL",
    "symbol": "R$"
  },
  {
    "name": "Bahamian Dollar",
    "code": "BSD",
    "symbol": "$"
  },
  {
    "name": "Bhutanese Ngultrum",
    "code": "BTN",
    "symbol": "Nu."
  },
  {
    "name": "Botswana Pula",
    "code": "BWP",
    "symbol": "P"
  },
  {
    "name": "Belarusian Ruble",
    "code": "BYN",
    "symbol": "Br"
  },
  {
    "name": "Belize Dollar",
    "code": "BZD",
    "symbol": "BZ$"
  },
  {
    "name": "Canadian Dollar",
    "code": "CAD",
    "symbol": "CA$"
  },
  {
    "name": "Congolese Franc",
    "code": "CDF",
    "symbol": "FC"
  },
  {
    "name": "Swiss Franc",
    "code": "CHF",
    "symbol": "Fr."
  },
  {
    "name": "Cook Islands Dollar",
    "code": "CKD",
    "symbol": "$"
  },
  {
    "name": "Chilean Peso",
    "code": "CLP",
    "symbol": "CL$"
  },
  {
    "name": "Chinese Yuan",
    "code": "CNY",
    "symbol": "CN¥"
  },
  {
    "name": "Colombian Peso",
    "code": "COP",
    "symbol": "CO$"
  },
  {
    "name": "Costa Rican Colon",
    "code": "CRC",
    "symbol": "₡"
  },
  {
    "name": "Cuban convertible Peso",
    "code": "CUC",
    "symbol": "CUC$"
  },
  {
    "name": "Cuban Peso",
    "code": "CUP",
    "symbol": "$MN"
  },
  {
    "name": "Cabo Verdean Escudo",
    "code": "CVE",
    "symbol": "CV$"
  },
  {
    "name": "Czech Koruna",
    "code": "CZK",
    "symbol": "Kč"
  },
  {
    "name": "Djiboutian Franc",
    "code": "DJF",
    "symbol": "Fdj"
  },
  {
    "name": "Danish Krone",
    "code": "DKK",
    "symbol": "kr."
  },
  {
    "name": "Dominican Peso",
    "code": "DOP",
    "symbol": "RD$"
  },
  {
    "name": "Algerian Dinar",
    "code": "DZD",
    "symbol": "DA"
  },
  {
    "name": "Egyptian Pound",
    "code": "EGP",
    "symbol": "E£"
  },
  {
    "name": "Sahrawi Peseta",
    "code": "EHP",
    "symbol": "Ptas."
  },
  {
    "name": "Eritrean Nakfa",
    "code": "ERN",
    "symbol": "Nkf"
  },
  {
    "name": "Ethiopian Birr",
    "code": "ETB",
    "symbol": "Br"
  },
  {
    "name": "Fijian Dollar",
    "code": "FJD",
    "symbol": "FJ$"
  },
  {
    "name": "Falkland Islands Pound",
    "code": "FKP",
    "symbol": "FK£"
  },
  {
    "name": "Faroese Króna",
    "code": "FOK",
    "symbol": "kr"
  },
  {
    "name": "Pound Sterling",
    "code": "GBP",
    "symbol": "£"
  },
  {
    "name": "Georgian Lari",
    "code": "GEL",
    "symbol": "₾"
  },
  {
    "name": "Guernsey Pound",
    "code": "GGP",
    "symbol": "£"
  },
  {
    "name": "Ghanaian Cedi",
    "code": "GHS",
    "symbol": "GH₵"
  },
  {
    "name": "Gibraltar Pound",
    "code": "GIP",
    "symbol": "£"
  },
  {
    "name": "Gambian Dalasi",
    "code": "GMD",
    "symbol": "D"
  },
  {
    "name": "Guinean Franc",
    "code": "GNF",
    "symbol": "FG"
  },
  {
    "name": "Guatemalan Quetzal",
    "code": "GTQ",
    "symbol": "Q"
  },
  {
    "name": "Guyanese Dollar",
    "code": "GYD",
    "symbol": "G$"
  },
  {
    "name": "Hong Kong Dollar",
    "code": "HKD",
    "symbol": "HK$"
  },
  {
    "name": "Honduran Lempira",
    "code": "HNL",
    "symbol": "L"
  },
  {
    "name": "Croatian Kuna",
    "code": "HRK",
    "symbol": "kn"
  },
  {
    "name": "Haitian Gourde",
    "code": "HTG",
    "symbol": "G"
  },
  {
    "name": "Hungarian Forint",
    "code": "HUF",
    "symbol": "Ft"
  },
  {
    "name": "Indonesian Rupiah",
    "code": "IDR",
    "symbol": "Rp"
  },
  {
    "name": "Israeli new Shekel",
    "code": "ILS",
    "symbol": "₪"
  },
  {
    "name": "Manx Pound",
    "code": "IMP",
    "symbol": "£"
  },
  {
    "name": "Indian Rupee",
    "code": "INR",
    "symbol": "Rs."
  },
  {
    "name": "Iraqi Dinar",
    "code": "IQD",
    "symbol": "د.ع."
  },
  {
    "name": "Iranian Rial",
    "code": "IRR",
    "symbol": "﷼"
  },
  {
    "name": "Icelandic Krona",
    "code": "ISK",
    "symbol": "kr"
  },
  {
    "name": "Jersey Pound",
    "code": "JEP",
    "symbol": "£"
  },
  {
    "name": "Jamaican Dollar",
    "code": "JMD",
    "symbol": "J$"
  },
  {
    "name": "Jordanian Dinar",
    "code": "JOD",
    "symbol": "JD"
  },
  {
    "name": "Japanese Yen",
    "code": "JPY",
    "symbol": "¥"
  },
  {
    "name": "Kenyan Shilling",
    "code": "KES",
    "symbol": "KSh"
  },
  {
    "name": "Kyrgyzstani Som",
    "code": "KGS",
    "symbol": "с"
  },
  {
    "name": "Cambodian Riel",
    "code": "KHR",
    "symbol": "៛"
  },
  {
    "name": "Kiribati Dollar",
    "code": "KID",
    "symbol": "$"
  },
  {
    "name": "Comorian Franc",
    "code": "KMF",
    "symbol": "CF"
  },
  {
    "name": "North Korean Won",
    "code": "KPW",
    "symbol": "₩"
  },
  {
    "name": "South Korean Won",
    "code": "KRW",
    "symbol": "₩"
  },
  {
    "name": "Kuwaiti Dinar",
    "code": "KWD",
    "symbol": "KD"
  },
  {
    "name": "Cayman Islands Dollar",
    "code": "KYD",
    "symbol": "CI$"
  },
  {
    "name": "Kazakhstani Tenge",
    "code": "KZT",
    "symbol": "₸"
  },
  {
    "name": "Lao Kip",
    "code": "LAK",
    "symbol": "₭N"
  },
  {
    "name": "Lebanese Pound",
    "code": "LBP",
    "symbol": "LL."
  },
  {
    "name": "Sri Lankan Rupee",
    "code": "LKR",
    "symbol": "Rs."
  },
  {
    "name": "Liberian Dollar",
    "code": "LRD",
    "symbol": "L$"
  },
  {
    "name": "Lesotho Loti",
    "code": "LSL",
    "symbol": "L"
  },
  {
    "name": "Libyan Dinar",
    "code": "LYD",
    "symbol": "LD"
  },
  {
    "name": "Moroccan Dirham",
    "code": "MAD",
    "symbol": "DH"
  },
  {
    "name": "Moldovan Leu",
    "code": "MDL",
    "symbol": "L"
  },
  {
    "name": "Malagasy Ariary",
    "code": "MGA",
    "symbol": "Ar"
  },
  {
    "name": "Macedonian Denar",
    "code": "MKD",
    "symbol": "den"
  },
  {
    "name": "Myanmar Kyat",
    "code": "MMK",
    "symbol": "Ks"
  },
  {
    "name": "Mongolian Tögrög",
    "code": "MNT",
    "symbol": "₮"
  },
  {
    "name": "Macanese Pataca",
    "code": "MOP",
    "symbol": "MOP$"
  },
  {
    "name": "Mauritanian Ouguiya",
    "code": "MRU",
    "symbol": "UM"
  },
  {
    "name": "Mauritian Rupee",
    "code": "MUR",
    "symbol": "Rs."
  },
  {
    "name": "Maldivian Rufiyaa",
    "code": "MVR",
    "symbol": "MRf"
  },
  {
    "name": "Malawian Kwacha",
    "code": "MWK",
    "symbol": "MK"
  },
  {
    "name": "Mexican Peso",
    "code": "MXN",
    "symbol": "MX$"
  },
  {
    "name": "Malaysian Ringgit",
    "code": "MYR",
    "symbol": "RM"
  },
  {
    "name": "Mozambican Metical",
    "code": "MZN",
    "symbol": "MTn"
  },
  {
    "name": "Namibian Dollar",
    "code": "NAD",
    "symbol": "N$"
  },
  {
    "name": "Nigerian Naira",
    "code": "NGN",
    "symbol": "₦"
  },
  {
    "name": "Nicaraguan Córdoba",
    "code": "NIO",
    "symbol": "C$"
  },
  {
    "name": "Norwegian Krone",
    "code": "NOK",
    "symbol": "kr"
  },
  {
    "name": "Nepalese Rupee",
    "code": "NPR",
    "symbol": "Rs."
  },
  {
    "name": "New Zealand Dollar",
    "code": "NZD",
    "symbol": "NZ$"
  },
  {
    "name": "Omani Rial",
    "code": "OMR",
    "symbol": "OR"
  },
  {
    "name": "Panamanian Balboa",
    "code": "PAB",
    "symbol": "B/."
  },
  {
    "name": "Peruvian Sol",
    "code": "PEN",
    "symbol": "S/."
  },
  {
    "name": "Papua New Guinean Kina",
    "code": "PGK",
    "symbol": "K"
  },
  {
    "name": "Philippine Peso",
    "code": "PHP",
    "symbol": "₱"
  },
  {
    "name": "Pakistani Rupee",
    "code": "PKR",
    "symbol": "Rs."
  },
  {
    "name": "Polish Zloty",
    "code": "PLN",
    "symbol": "zł"
  },
  {
    "name": "Pitcairn Islands Dollar",
    "code": "PND",
    "symbol": "$"
  },
  {
    "name": "Transnistrian Ruble",
    "code": "PRB",
    "symbol": "р."
  },
  {
    "name": "Paraguayan Guaraní",
    "code": "PYG",
    "symbol": "₲"
  },
  {
    "name": "Qatari Riyal",
    "code": "QAR",
    "symbol": "QR"
  },
  {
    "name": "Romanian Leu",
    "code": "RON",
    "symbol": "L"
  },
  {
    "name": "Serbian Dinar",
    "code": "RSD",
    "symbol": "din"
  },
  {
    "name": "Russian Ruble",
    "code": "RUB",
    "symbol": "₽"
  },
  {
    "name": "Rwandan Franc",
    "code": "RWF",
    "symbol": "FRw"
  },
  {
    "name": "Saudi Riyal",
    "code": "SAR",
    "symbol": "SR"
  },
  {
    "name": "Solomon Islands Dollar",
    "code": "SBD",
    "symbol": "SI$"
  },
  {
    "name": "Seychellois Rupee",
    "code": "SCR",
    "symbol": "Rs."
  },
  {
    "name": "Sudanese Pound",
    "code": "SDG",
    "symbol": "£SD"
  },
  {
    "name": "Swedish Krona",
    "code": "SEK",
    "symbol": "kr"
  },
  {
    "name": "Singapore Dollar",
    "code": "SGD",
    "symbol": "S$"
  },
  {
    "name": "Saint Helena Pound",
    "code": "SHP",
    "symbol": "£"
  },
  {
    "name": "Sierra Leonean Leone",
    "code": "SLL",
    "symbol": "Le"
  },
  {
    "name": "Somaliland Shilling",
    "code": "SLS",
    "symbol": "Sl"
  },
  {
    "name": "Somali Shilling",
    "code": "SOS",
    "symbol": "Sh.So."
  },
  {
    "name": "Surinamese Dollar",
    "code": "SRD",
    "symbol": "Sr$"
  },
  {
    "name": "South Sudanese Pound",
    "code": "SSP",
    "symbol": "SS£"
  },
  {
    "name": "Sao Tome and Príncipe Dobra",
    "code": "STN",
    "symbol": "Db"
  },
  {
    "name": "Salvadoran Colón",
    "code": "SVC",
    "symbol": "₡"
  },
  {
    "name": "Syrian Pound",
    "code": "SYP",
    "symbol": "LS"
  },
  {
    "name": "Swazi Lilangeni",
    "code": "SZL",
    "symbol": "L"
  },
  {
    "name": "Thai Baht",
    "code": "THB",
    "symbol": "฿"
  },
  {
    "name": "Tajikistani Somoni",
    "code": "TJS",
    "symbol": "SM"
  },
  {
    "name": "Turkmenistan Manat",
    "code": "TMT",
    "symbol": "m."
  },
  {
    "name": "Tunisian Dinar",
    "code": "TND",
    "symbol": "DT"
  },
  {
    "name": "Tongan Paʻanga",
    "code": "TOP",
    "symbol": "T$"
  },
  {
    "name": "Turkish Lira",
    "code": "TRY",
    "symbol": "TL"
  },
  {
    "name": "Trinidad and Tobago Dollar",
    "code": "TTD",
    "symbol": "TT$"
  },
  {
    "name": "Tuvaluan Dollar",
    "code": "TVD",
    "symbol": "$"
  },
  {
    "name": "New Taiwan Dollar",
    "code": "TWD",
    "symbol": "NT$"
  },
  {
    "name": "Tanzanian Shilling",
    "code": "TZS",
    "symbol": "TSh"
  },
  {
    "name": "Ukrainian Hryvnia",
    "code": "UAH",
    "symbol": "₴"
  },
  {
    "name": "Ugandan Shilling",
    "code": "UGX",
    "symbol": "USh"
  },
  {
    "name": "Uruguayan Peso",
    "code": "UYU",
    "symbol": "$U"
  },
  {
    "name": "Uzbekistani Som",
    "code": "UZS",
    "symbol": "сум"
  },
  {
    "name": "Venezuelan bolívar digital",
    "code": "VED",
    "symbol": "Bs."
  },
  {
    "name": "Venezuelan Bolívar Soberano",
    "code": "VES",
    "symbol": "Bs.F"
  },
  {
    "name": "Vietnamese Dong",
    "code": "VND",
    "symbol": "₫"
  },
  {
    "name": "Vanuatu Vatu",
    "code": "VUV",
    "symbol": "VT"
  },
  {
    "name": "Samoan Tala",
    "code": "WST",
    "symbol": "T"
  },
  {
    "name": "Central African CFA Franc BEAC",
    "code": "XAF",
    "symbol": "Fr"
  },
  {
    "name": "East Caribbean Dollar",
    "code": "XCD",
    "symbol": "$"
  },
  {
    "name": "West African CFA Franc BCEAO",
    "code": "XOF",
    "symbol": "₣"
  },
  {
    "name": "CFP Franc (Franc Pacifique)",
    "code": "XPF",
    "symbol": "₣"
  },
  {
    "name": "Yemeni Rial",
    "code": "YER",
    "symbol": "YR"
  },
  {
    "name": "South African Rand",
    "code": "ZAR",
    "symbol": "R"
  },
  {
    "name": "Zambian Kwacha",
    "code": "ZMW",
    "symbol": "ZK"
  },
  {
    "name": "RTGS Dollar",
    "code": "ZWB",
    "symbol": ""
  },
  {
    "name": "Zimbabwean Dollar",
    "code": "ZWL",
    "symbol": "Z$"
  },
  {
    "name": "Abkhazian Apsar",
    "code": "ABKHAZIA",
    "symbol": ""
  },
  {
    "name": "Artsakh Dram",
    "code": "ARTSAKH",
    "symbol": "դր."
  }
]
